module.exports = __webpack_public_path__ + "img/bandeau-JPO-1.c10af5e.png";